import $ from "jquery";
import "slick-carousel";


$(document).on('mouseover', '.ota-hover', function() {
   $(this).removeClass("reveal_visible").delay(10).queue(function(){
    $(this).addClass("reveal_visible").dequeue();
  });;


  });
  $(document).on('mouseleave', '.ota-hover', function() {
    if ($(".ota-scroll")[0]){
      return null;
    }else{
    $(this).removeClass("reveal_visible");
    }
  
});
$(document).ready(function() {

  //window and animation items
  var animation_elements = $.find('.ota-scroll');
  var web_window = $(window);

  //check to see if any animation containers are currently in view
  function check_if_in_view() {
    //get current window information
    var window_height = web_window.height();
    var window_top_position = web_window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    //iterate through elements to see if its in view
    $.each(animation_elements, function() {

      //get the element sinformation
      var element = $(this);
      var element_height = $(element).outerHeight();
      var element_top_position = $(element).offset().top;
      var element_bottom_position = (element_top_position + element_height) ;

      //check to see if this current container is visible (its viewable if it exists between the viewable space of the viewport)
      if ((element_bottom_position >= window_top_position ) && (element_top_position <= window_bottom_position)) {
        if($(element).hasClass("has-type-focus")){
          
          element.addClass('reveal_visible');
          $("body").addClass("with_promo_slide");
       
        }else{
          element.addClass('reveal_visible');
        }
        
        
      } else {
        
           
           if($(element).hasClass("has-type-focus"))
            {
              element.removeClass('reveal_visible');
              $("body").removeClass("with_promo_slide");
            }

        
      }
    });

  }

  //on or scroll, detect elements in view
  $(window).on('scroll resize', function() {
      check_if_in_view()
    })
    //trigger our scroll event on initial load
  $(window).trigger('scroll');

});
